export function getConfigValue(
  configs: { key: string; value?: string[] }[],
  key: string
): string | undefined {
  return configs.find(c => c.key === key)?.value?.[0];
}

export function getConfigFlag(
  configs: { key: string; value?: string[] }[],
  key: string
): boolean {
  return getConfigValue(configs, key)?.toLowerCase() === 'true';
}

export function hasReverseScaleOrder(
  configs: { key: string; value?: string[] }[],
  raw: { additional?: { reverseScaleOrder?: boolean; reverseScale?: boolean } }
): boolean {
  return (
    configs.some(c => c.key.includes('REVERSE') && c.value?.[0]?.toLowerCase() === 'true') ||
    raw.additional?.reverseScaleOrder === true ||
    raw.additional?.reverseScale === true
  );
}

export function hasNotApplicableOption(configs: { key: string; value?: string[] }[]): boolean {
  return (
    getConfigFlag(configs, 'NOT_APPLICABLE_OPTIONS') ||
    getConfigFlag(configs, 'ENABLE_NON_APPLICABLE')
  );
}
